import i from "./ghl-ui.es1288.js";
var l = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function u(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + l[e] + " scorso alle' p";
  }
}
function s(e) {
  return "'" + l[e] + " alle' p";
}
function f(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + l[e] + " prossimo alle' p";
  }
}
var c = {
  lastWeek: function(t, a, o) {
    var r = t.getUTCDay();
    return i(t, a, o) ? s(r) : u(r);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(t, a, o) {
    var r = t.getUTCDay();
    return i(t, a, o) ? s(r) : f(r);
  },
  other: "P"
}, m = function(t, a, o, r) {
  var n = c[t];
  return typeof n == "function" ? n(a, o, r) : n;
};
const p = m;
export {
  p as default
};
